import * as React from "react";

const DrawerContext = React.createContext<any>({});

export default DrawerContext;
